
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { dataService } from "../../../services/data.services";


const initialState = {
    loading: true,
    error: '',
    success: '',
}
export const FeeStructure = createAsyncThunk('FeeStructure', async (searchParams) => {
    let res = await dataService.GetAPI(searchParams);
    return res
})
const FeeStructureSlice = createSlice({

    name: 'FeeStructure',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = true
        }

    },
    extraReducers: {
        [FeeStructure.pending]: (state) => {
            state.loading = true
            state.error = null
        },
        [FeeStructure.fulfilled]: (state, action) => {
            state.loading = false;
            if(!action?.payload?.error && action?.payload?.data.status===200){
                state.List=action?.payload?.data.data;
                
            }else{
                state.error=action?.payload?.data?.message
            }
        },
        [FeeStructure.rejected]: (state, { payload }) => {
            state.loading = false
            state.error = payload?.message?.message
        },
    },
})
export const { setLoading } = FeeStructureSlice.actions;
export default FeeStructureSlice.reducer